import React, { useState, useEffect, useRef } from "react";
import Button from "~components/Button";
// import { DocumentContext } from "~context/DocumentContext";
import { createPipedriveDeal } from "~utils/pipedrive";
import { fancyWarning, validateEmail } from "~utils/helpers";

const ContactForm = () => {
  // const { device } = useContext(DocumentContext);

  const submitRef = useRef();

  const [form, setForm] = useState({
    name: ``,
    company: ``,
    email: ``,
    phone: ``,
    country: ``,
    timezone: ``,
    message: ``,
    feelgood: false
  });
  // const [feelGood] = useState
  // add check input in form
  // if check add to description var
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    console.log(form);
  }, [form]);

  const onChange = e => {
    const { target } = e;
    const value = target.type === `checkbox` ? target.checked : target.value;
    const { name } = target;

    setForm({
      ...form,
      [name]: value
    });
  };

  const submitProxy = () => {
    if (!submitRef?.current) {
      return;
    }

    submitRef.current.click();
  };

  const onSubmit = e => {
    e.preventDefault();

    const description = `
      Name: ${form.name}
      Company: ${form.company}
      Email: ${form.email}
      Phone: ${form.phone}
      Country: ${form.country}
      Timezone: ${form.timezone}
      Message: ${form.message}
      FeelGood: ${form.feelgood}
      `;

    //
    // localhost bailout

    if (
      typeof window !== `undefined` &&
      window.location.href.includes(`localhost:8000`)
    ) {
      console.log(`Local host true`);
      setSubmitting(true);

      setTimeout(() => {
        console.log(description);

        setSubmitting(false);
        setSubmitted(true);
        setForm({
          name: ``,
          company: ``,
          email: ``,
          phone: ``,
          country: ``,
          timezone: ``,
          message: ``,
          feelgood: false
        });
        setDisabled(true);
      }, 3000);

      return false;
    }

    if (submitting || submitted) {
      return false;
    }

    //
    // lambda invocation

    setSubmitting(true);

    if (
      !form?.name ||
      !form?.company ||
      !form?.email ||
      !validateEmail(form.email)
    ) {
      fancyWarning(`Incomplete data`);
      return false;
    }

    //

    createPipedriveDeal({
      "title": form.company,
      "5ea9ab43a4b506b7c7514c9d1b34aa44f98bb96a": description
    }).then(response => {
      response.json().then(jsonData => {
        console.log(`Sent form!`, jsonData);
        setSubmitting(false);
        setSubmitted(true);
        setForm({
          name: ``,
          company: ``,
          email: ``,
          phone: ``,
          country: ``,
          timezone: ``,
          message: ``,
          feelgood: false
        });
        setDisabled(true);
      });
    });

    return false;
  };
  return (
    <>
      <p
        className={`mb-1 xs:mb-v5 b3 universal-sans ${
          disabled ? `opacity-50` : ``
        }`}
      >
        Your contact details:
      </p>

      <form
        className={`footer__form grid-end-6 xs:grid-end-8 ${
          disabled ? `opacity-50` : ``
        }`}
        onSubmit={onSubmit}
      >
        <input
          ref={submitRef}
          className={`w-0 h-0 absolute opacity-0 pointer-events-none ${
            disabled ? `opacity-50` : ``
          }`}
          type="submit"
          disabled={disabled}
        />

        <div className="w-full relative flex">
          <input
            name="name"
            className={`footer__form__input footer__form__input--left w-1/2 relative block bg-white b3 universal-sans text-gold ${
              disabled ? `opacity-50` : ``
            }`}
            onChange={onChange}
            placeholder="Full Name*"
            value={form.name}
            readOnly={submitting || submitted}
            required
            type="text"
            disabled={disabled}
          />

          <input
            name="company"
            className={`footer__form__input footer__form__input--right w-1/2 relative block bg-white b3 universal-sans text-gold ${
              disabled ? `opacity-50` : ``
            }`}
            onChange={onChange}
            placeholder="Company*"
            value={form.company}
            readOnly={submitting || submitted}
            required
            type="text"
            disabled={disabled}
          />
        </div>

        <div className="w-full relative flex">
          <input
            name="email"
            className={`footer__form__input footer__form__input--left w-1/2 relative block bg-white b3 universal-sans text-gold ${
              disabled ? `opacity-50` : ``
            }`}
            onChange={onChange}
            placeholder="Email*"
            value={form.email}
            readOnly={submitting || submitted}
            required
            type="email"
            disabled={disabled}
          />

          <input
            name="phone"
            className={`footer__form__input footer__form__input--right w-1/2 relative block bg-white b3 universal-sans text-gold ${
              disabled ? `opacity-50` : ``
            }`}
            onChange={onChange}
            placeholder="Phone"
            value={form.phone}
            readOnly={submitting || submitted}
            type="text"
            disabled={disabled}
          />
        </div>

        <div className="w-full relative flex">
          <input
            name="country"
            className={`footer__form__input footer__form__input--left w-1/2 relative block b3   universal-sans bg-white text-gold ${
              disabled ? `opacity-50` : ``
            }`}
            onChange={onChange}
            placeholder="Country"
            value={form.country}
            readOnly={submitting || submitted}
            type="text"
            disabled={disabled}
          />

          <input
            name="timezone"
            className={`footer__form__input footer__form__input--right w-1/2 relative block b3   universal-sans bg-white text-gold ${
              disabled ? `opacity-50` : ``
            }`}
            onChange={onChange}
            placeholder="Timezone"
            value={form.timezone}
            readOnly={submitting || submitted}
            type="text"
            disabled={disabled}
          />
        </div>

        <textarea
          name="message"
          className={`footer__form__textarea w-full relative block pt-v2 b3  universal-sans text-gold ${
            disabled ? `opacity-50` : ``
          }`}
          onChange={onChange}
          placeholder="How can we help?"
          value={form.message}
          required
          rows={4}
          disabled={disabled}
        />

        <div className="w-full relative flex mt-v1 xs:mt-v2 mb-v1 xs:mb-v2">
          <input
            // type="radio"
            type="checkbox"
            id="feelgood"
            name="feelgood"
            checked={form.feelgood}
            onChange={onChange}
            className={`footer__form__checkbox mr-v1 xs:mr-v2 ${
              disabled ? `opacity-50` : ``
            }`}
            disabled={disabled}
          />
          <label htmlFor="feelgood" className="b3 universal-sans">
            Feel Good Do Good discount. If you think your brand is doing
            something extraordinary for our pale blue dot, please make yourself
            known.
          </label>
        </div>

        <Button
          className={`button--contact ${
            submitted || submitting ? `opacity-50 pointer-events-none` : ``
          } footer__submit w-auto xs:mt-v3 mx-auto`}
          color="rad"
          filled
          onClick={() => {
            if (submitted || submitting) {
              return;
            }

            submitProxy();
          }}
          text={`${submitted ? `Thanks!` : `Whoosh`}`}
        />
      </form>
    </>
  );
};

export default ContactForm;
